import { useTranslation } from "react-i18next"

import { COOKIES_GROUPS } from "./cookiesData"

// Tabla de cookies renderizada con JSX a partir de datos estructurados
// (sin dangerouslySetInnerHTML). Reutiliza los estilos de tabla de
// LegalPageContent (.content table/th/td) al renderizarse dentro de él.
const CookiesTable = () => {
  const { t } = useTranslation()

  return (
    <>
      {COOKIES_GROUPS.map(group => (
        <div key={group.category}>
          <h3>{t(`cookiesTable.cat_${group.category}`)}</h3>
          <table>
            <thead>
              <tr>
                <th>{t("cookiesTable.name")}</th>
                <th>{t("cookiesTable.provider")}</th>
                <th>{t("cookiesTable.purpose")}</th>
                <th>{t("cookiesTable.retention")}</th>
              </tr>
            </thead>
            <tbody>
              {group.cookies.map(cookie => (
                <tr key={cookie.key}>
                  <td>{cookie.names}</td>
                  <td>{cookie.provider}</td>
                  <td>{t(`cookiesPurpose.${cookie.key}`)}</td>
                  <td>{t(`cookiesRetention.${cookie.key}`)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </>
  )
}

export default CookiesTable
